import { axios } from '@/utils'

const RESOURCE_NAME = '/common'

export default {
  send_email (payload) {
    return axios.post(`${RESOURCE_NAME}/send-email-from-site`, payload)
  }
}
